import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { PartnerDto, SchoolBillDto, SchoolLevel, SchoolSubPayDto,  SchoolSubsClassDto,  SchoolSubscTransportDto, SchoolSubsItemValue } from '../api/models';
import { SchoolControllerService,  SchoolSubscriptionPaymentCtlService } from '../api/services';

import * as bootstrap from 'bootstrap';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-school-subscription-payment',
  imports: [ReactiveFormsModule],
  templateUrl: './school-subscription-payment.component.html',
  styleUrl: './school-subscription-payment.component.css'
})
export class SchoolSubscriptionPaymentComponent implements OnInit {

  studentForm: FormGroup;
  payForm: FormGroup;
  phoneForm:FormGroup;
  schools: Array<PartnerDto> = Array.of();
  message = '';
  classes: Array<SchoolSubsClassDto> = Array.of();
  levels:Array<SchoolLevel> =Array.of();
  selectedClasses:Array<SchoolSubsClassDto> = Array.of();
  requiredItems:Array<SchoolSubsItemValue> =Array.of();
  nonRequiredItems:Array<SchoolSubsItemValue> =Array.of();
  selectedItems:Array<SchoolSubsItemValue> =Array.of();
  reliquat?: SchoolBillDto;
  transports: Array<SchoolSubscTransportDto> = Array.of();
  currentClass?: SchoolSubsClassDto;
  currentTransport?: SchoolSubscTransportDto;
  totalAmount = 0;
  transportSubsScription = false;
  paymentNetwork ='';
  idSchool:number=0;
  idStudent:string='';
  fees:number=0;
   currentIdTransport:number=0;
   idempotencyKey:string = '';
   processing=false;




  constructor(
    private schoolService: SchoolControllerService,
    private schoolSubscripService: SchoolSubscriptionPaymentCtlService,
    private formBuilder: FormBuilder
  ) {
    this.studentForm = this.formBuilder.group(
      {
        idSchool: ['', Validators.required],
        idStudent: ['', Validators.required]
      }
    );
    this.payForm = this.formBuilder.group(
      {
        idLevel: ['', [Validators.required, Validators.min(1)]],
        idReliquat: ['', Validators.required],
        idTransport: ['', Validators.required],
        idClass: ['', Validators.required],
      }
    );
    this.phoneForm = this.formBuilder.group({
      'phone':['',Validators.required]
    });

  }
  
  ngOnInit(): void {
    this.loadSchools();
  }

  loadSchools() {
    this.schoolService.findSchool(
      environment.codeParent,
      environment.codeCountry
    ).subscribe(
      {
        next: (resp) => {
          this.schools = resp;

        },
        error: (err) => {
          this.message = err.error.message;
          const modAdd = new bootstrap.Modal('#errorDialog', {});
          modAdd.show();

        }
      }
    );
  }

  findSubscriptionSubscriptionInfo() {

    let form = this.studentForm.value;
    console.log(form);

    this.schoolSubscripService.subscriptionInfo(
      form.idSchool,
      form.idStudent
).subscribe(
      {
        next: (resp) => {
          this.classes = resp.classes!!;
          this.levels =[];
          this.classes.forEach(cls=>{
            let fi =this.levels.find(lev=>lev.id==cls.classe.level!!.id);
            if(!fi){
              this.levels.push(cls.classe.level!!);
            }});
            
          this.idStudent=form.idStudent;
          this.idSchool=form.idSchool;
          this.transports = resp.transports!!;
          this.reliquat = resp.reliquat;
          this.currentClass = undefined;
          this.currentTransport = undefined;
          this.payForm.controls['idReliquat'].setValue(this.reliquat?.id);
          
          this.calculateTotalAmount();
        }
        ,
        error: (err) => {
          this.message = err.error.message;
          const modAdd = new bootstrap.Modal('#errorDialog', {});
          modAdd.show();
        }
      }
    )
  }
onChangeClass(){
    let idClass= this.payForm.value.idClass;
    console.log(this.payForm.value);
    console.log("change class",idClass);
    console.log(this.selectedClasses);
    if (idClass.length>0) {
      this.currentClass = this.classes.find(x => x.classe.id == idClass)!!;
      this.requiredItems=[];
      this.selectedItems =[];
      this.nonRequiredItems =[];
      this.requiredItems = this.currentClass.otherItems?.filter(it=>it.mandatory==true)!!;
      this.nonRequiredItems = this.currentClass.otherItems?.filter(it=>it.mandatory==false)!!;
      console.log(this.currentClass);
      } else {
      this.currentClass = undefined;
      this.currentTransport = undefined;
    }
    this.payForm.controls['idTransport'].setValue('0');
    this.calculateTotalAmount();
    
  }
  onChangeLevel() {
      let idLevel =this.payForm.value.idLevel;
      if(idLevel.length>0){
      this.selectedClasses =[];

      this.classes.forEach(cls =>{
        if(cls.classe.level?.id==idLevel){
          this.selectedClasses.push(cls);
        }
      })
      }

  }
  onSelectTransport() {
    let idTransport = Number(this.payForm.value.idTransport);
    this.currentIdTransport = idTransport;
    if (idTransport > 0) {
      this.currentTransport = this.transports.find(x => x.id === idTransport);
    } else {
      
      this.currentTransport = undefined;
    }
    this.calculateTotalAmount();
  }
  onSubscription() {

    let form = this.payForm.value;
    console.log(form);
    this.paymentNetwork ='';
    if (this.transportSubsScription === true && this.currentTransport==undefined) {
          this.message = "Veuillez sélectionner un itinéraire ou décocher la case d'abonnement au transport";
          const modAdd = new bootstrap.Modal('#errorDialog', {});
          modAdd.show();
          return;
        }else {
    const modAdd = new bootstrap.Modal('#payDialog', {});
    modAdd.show();
        }
  }

  calculateTotalAmount() {

    let amount = this.reliquat!!.amount!!;

    if (this.currentClass != undefined) {
      amount = amount + this.currentClass.apecAmount + this.currentClass.yearlyFee;
      amount = amount  +this.currentClass.firstMonthAmount;
      
    }
    if(this.selectedItems.length>0){
      let itemsAmount =0;
      this.selectedItems.forEach(function(item){
        itemsAmount = itemsAmount+item.value!!;
      });
      amount = amount+itemsAmount;
    }
    if(this.requiredItems.length>0){
      let itemsAmount =0;
      this.requiredItems.forEach(function(item){
        itemsAmount = itemsAmount+item.value!!;
      });
      amount = amount+itemsAmount;
    }
    if (this.currentTransport != undefined) {
      amount = amount + this.currentTransport.monthlyAmount + this.currentTransport.subscription;
    }


    this.totalAmount = amount;
    console.log(amount)
  }
  /*onCantineChange() {
    console.log('change cantine');
    this.cantineSubsScription = !this.cantineSubsScription;
    this.payForm.controls['cantineSubsScription'].setValue(this.cantineSubsScription);
    this.calculateTotalAmount()

  }*/
  onTransportChange(){
     this.transportSubsScription = !this.transportSubsScription;
     if(!this.transportSubsScription){ 
      this.payForm.controls['idTransport'].updateValueAndValidity();
      this.payForm.controls['idTransport'].setValue(0);
     }
    this.calculateTotalAmount()
  }

  onPaySubscription(){

    let networkOption='';
    this.processing =true;
    if(this.paymentNetwork =='OMSN'){
      networkOption='maxit';
    }
    let payDto:SchoolSubPayDto={
      idReliquat:this.reliquat?.id!!,
      idStudent:this.idStudent,
      idSubscriptionClass: this.currentClass?.id!!,
      parentName:this.reliquat?.parentFirstName+' '+this.reliquat?.parentLastName,
      studentName:this.reliquat?.studentName!!,
      idTransport: this.currentIdTransport,
      paymentMethod: this.paymentNetwork,
      paymentNetwork:this.paymentNetwork,
      paymentNetworkOption: networkOption,
      items:this.selectedItems

    };
    this.schoolSubscripService.subscriptionPayment(
      payDto
  ).subscribe({
      next:(resp)=>{
        this.processing=false;
        if(resp.paymentUrl){
          window.open(resp.paymentUrl,'_self');

        }else {
          this.message = "Paiement echoué veuillez réessayer";
          const modAdd = new bootstrap.Modal('#errorDialog', {});
          modAdd.show();
        }

      },
      error:(err)=>{
        this.processing=false;
        this.message = err.error.message;
          const modAdd = new bootstrap.Modal('#errorDialog', {});
          modAdd.show();
      }
    })
    
  }
  onCancelSubscription(){

    this.payForm.reset();
    this.currentClass=undefined;
    this.currentTransport=undefined;
    this.totalAmount=0;
    this.classes =Array.of();
    this.transports =Array.of();
    this.reliquat=undefined;
    this.paymentNetwork='';

  }

  onSelectPaymentMethod(paymentNetwork:string){

    this.paymentNetwork =paymentNetwork.toUpperCase();
    const methods = document.querySelectorAll('.payment-method');
    methods.forEach(element => {
      
      if(element.getAttribute('data-method') == paymentNetwork){
         element.classList.add('active');

      }else {
        element.classList.remove('active');
      }
      
    }); 

    this.schoolSubscripService.getPaymentFees(
    this.idSchool,
    this.totalAmount,
    this.paymentNetwork
        ).subscribe(
      {
        next:(resp)=>{
          this.fees =resp;
        },
        error:(err)=>{
           this.message = err.error.message;
          const modAdd = new bootstrap.Modal('#errorDialog', {});
          modAdd.show();
        }
      }
    );
  }
  returnToSearch(){
    this.onCancelSubscription();

  }
  onChangeItem(event:any,item:SchoolSubsItemValue){

     const isChecked = (event.target as HTMLInputElement).checked;
    console.log(isChecked);
    console.log(item);
    if(isChecked){
      this.selectedItems.push(item);
    }else {
      let index=this.selectedItems.findIndex(it=>item.libelle===item.libelle);
    if(index>=0){
      this.selectedItems.splice(index,1);
    }
    }
    this.calculateTotalAmount();
  }

}
